unit unit_EinzelBeleg;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.Buttons, Vcl.Controls, Vcl.StdCtrls,
  WEBLib.StdCtrls, WEBLib.ExtCtrls, Data.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, WEBLib.Grids, strutils, XData.Web.Client, DB;

type
  TEinzelBeleg = class(TForm)
    xdsBeleg: TXDataWebDataSet;
    TC: TTableControl;
    PTC: TTableControl;
    xdsPositionen: TXDataWebDataSet;
    Container1: THTMLContainer;
    Container2: THTMLContainer;
    btnzurueck: TButton;
    btnPDF: TButton;
    WClient: TXDataWebClient;
    procedure WebFormShow(Sender: TObject);
    procedure xdsBelegAfterOpen(DataSet: TDataSet);
    procedure xdsPositionenAfterOpen(DataSet: TDataSet);
    procedure btnPDFClick(Sender: TObject);
    procedure btnzurueckClick(Sender: TObject);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
    Belegnummer:string;
    Belegart:string;

  protected procedure LoadDFMValues; override; end;

var
  EinzelBeleg: TEinzelBeleg;
  Einkauf:boolean;

implementation
  uses unit1, unit2, unit_BelegeUndPositionen;
{$R *.dfm}

procedure TEinzelBeleg.btnPDFClick(Sender: TObject);
  procedure OnResponse(Response:TXDataClientResponse);
  var
    mydownload:string;
  begin
    mydownload:=string(TJSObject(response.Result)['value']);
    if mydownload='WRONG' then
    begin
      showmessage('Download kann nicht bereitgestellt werden');
    end
    else
    begin
      application.Navigate(downloadconnection+mydownload,ntblank);
    end;
  end;
begin
  if LizenzOK then
  begin
    WClient.RawInvoke('IServerService.BelegPDF',[Belegnummer],@OnResponse);
  end
  else
  begin
    showmessage('Für das Abrufen von Dateien sind Sie noch nicht freigeschaltet, bitte erwerben Sie eine Lizenz');
  end;

end;

procedure TEinzelBeleg.btnzurueckClick(Sender: TObject);
begin
  xdsbeleg.Close;

  self.Close;
end;

procedure TEinzelBeleg.WebFormShow(Sender: TObject);
var
  myelement:TJSHTMLElement;
begin
  Container1.html.text:='<nav class="navbar m-1 rounded bg-info"><h5>Einzelbeleg</h5></nav>';
  myelement:=container1.ElementHandle;
  btnzurueck.ParentElement:=myelement;
  btnPDF.ParentElement:=myelement;
  container2.ParentElement:=myelement;
  myelement:=container2.ElementHandle;
  tc.ParentElement:=myelement;
  ptc.ParentElement:=myelement;
  if Belegart='Angebote' then xdsbeleg.EntitySetName:='Angebote';
  if Belegart='Aufträge' then xdsbeleg.EntitySetName:='Auftrag';
  if Belegart='Lieferscheine' then xdsbeleg.EntitySetName:='Lieferschein';
  if Belegart='Rechnungen' then xdsbeleg.EntitySetName:='Rechnung';
  if Belegart='Anfragen' then xdsbeleg.EntitySetName:='Anfrage';
  if Belegart='Bestellungen' then xdsbeleg.EntitySetName:='Bestellung';
  if Belegart='Wareneingänge' then xdsbeleg.EntitySetName:='Wareneingang';
  if Belegart='EingangsRechnungen' then xdsbeleg.EntitySetName:='EingangsRE';

  if Belegart='Angebote' then Einkauf:=false;
  if Belegart='Aufträge' then Einkauf:=false;
  if Belegart='Lieferscheine' then Einkauf:=false;
  if Belegart='Rechnungen' then Einkauf:=false;
  if Belegart='Anfragen' then Einkauf:=true;
  if Belegart='Bestellungen' then Einkauf:=true;
  if Belegart='Wareneingänge' then Einkauf:=true;
  if Belegart='EingangsRechnungen' then Einkauf:=true;

  xdsBeleg.QueryString:='$expand=Kundennummer&$filter=Nummerkomplett eq '+QuotedStr(Belegnummer);
  xdsBeleg.Load;
end;

procedure TEinzelBeleg.xdsBelegAfterOpen(DataSet: TDataSet);
begin
  TC.RowCount:=8;
  TC.Cells[0,0]:='Bezeichnung';
  TC.Cells[1,0]:='Wert';
  if Belegart='Angebote' then TC.Cells[0,1]:='Angebot | Datum';
  if Belegart='Aufträge' then TC.Cells[0,1]:='Auftrrag | Datum';
  if Belegart='Lieferscheine' then TC.Cells[0,1]:='Lieferschein | Datum';
  if Belegart='Rechnungen' then TC.Cells[0,1]:='Rechnung | Datum';
  if Belegart='Anfragen' then TC.Cells[0,1]:='Anfrage | Datum';
  if Belegart='Bestellungen' then TC.Cells[0,1]:='Bestellung | Datum';
  if Belegart='Wareneingänge' then TC.Cells[0,1]:='Wareneingang | Datum';
  if Belegart='EingangsRechnungen' then TC.Cells[0,1]:='Eingangsrechnung | Datum';
  TC.Cells[1,1]:='<h5>'+xdsbeleg.FieldByName('Nummerkomplett').asstring +' | '+formatdatetime('DD.MM.YYYY',xdsbeleg.FieldByName('Datum').asdatetime);

  TC.Cells[0,2]:='Kontaktnummer';
  TC.Cells[1,2]:='<h6>'+xdsBeleg.FieldByName('Kundennummer.Kundennummer').asstring;

  TC.Cells[0,3]:='Anschrift';
  TC.Cells[1,3]:='<h6>'+ReplaceStr(xdsbeleg.FieldByName('Adressebild').asstring,#13+#10,'<BR>');

  TC.Cells[0,4]:='Auftragsbezeichnung';
  TC.Cells[1,4]:='<h6>'+xdsBeleg.FieldByName('Auftragsbezeichnung').asstring;

  TC.Cells[0,5]:='Objektnummer';
  TC.Cells[1,5]:='<h6>'+xdsBeleg.FieldByName('Objektnummer').asstring;

  TC.Cells[0,6]:='Lieferanschrift';
  try
  TC.Cells[1,6]:='<h6>'+ReplaceStr(xdsbeleg.FieldByName('Lieferanschriftbild').asstring,#13+#10,'<BR>');
  except
  end;
  TC.Cells[0,7]:='Nettosumme';
  if form1.rcw.Verkaufspreise=true then TC.Cells[1,7]:=formatfloat('#,##0.00',xdsbeleg.fieldbyname('Nettosumme').asfloat);
  if form1.rcw.Verkaufspreise=false then TC.Cells[1,7]:='XXX';

  xdspositionen.Close;
  if Belegart='Angebote' then xdsPositionen.EntitySetName:='PositionenAngebote';
  if Belegart='Aufträge' then xdsPositionen.EntitySetName:='PositionenAuftrag';
  if Belegart='Lieferscheine' then xdsPositionen.EntitySetName:='PositionenLieferschein';
  if Belegart='Rechnungen' then xdsPositionen.EntitySetName:='PositionenRechnung';
  if Belegart='Anfragen' then xdsPositionen.EntitySetName:='PositionenAnfrage';
  if Belegart='Bestellungen' then xdsPositionen.EntitySetName:='PositionenBestellung';
  if Belegart='Wareneingänge' then xdsPositionen.EntitySetName:='PositionenWareneingang';
  if Belegart='EingangsRechnungen' then xdsPositionen.EntitySetName:='PositionenEingangsRE';
  xdsPositionen.QueryString:='$expand=Artikelnummer&$filter=Nummerkomplett eq '+QuotedStr(Belegnummer)+'&$orderby=PosNr';
  xdsPositionen.Load;
end;

procedure TEinzelBeleg.xdsPositionenAfterOpen(DataSet: TDataSet);
var
  I: Integer;
begin
  PTC.RowCount:=xdsPositionen.RecordCount+1;
  PTC.ColCount:=8;
  PTC.Cells[0,0]:='PosNr';
  PTC.Cells[1,0]:='PosUNr';
  PTC.Cells[2,0]:='Artikelnummer';
  PTC.Cells[3,0]:='Artikelüberschrift';
  PTC.Cells[4,0]:='Beschreibung';
  PTC.Cells[5,0]:='Menge';
  PTC.Cells[6,0]:='Einzel-VKP';
  if Einkauf then PTC.Cells[6,0]:='Einzel-EKP';
  PTC.Cells[7,0]:='Endpreis';

  xdspositionen.First;
  btnpdf.Enabled:=true;
  for I := 1 to xdspositionen.RecordCount do
  begin
    PTC.Cells[0,i]:=xdspositionen.FieldByName('PosNr').AsString;
    PTC.Cells[1,i]:=xdspositionen.FieldByName('PosUNr').AsString;
    PTC.Cells[2,i]:=xdspositionen.FieldByName('Artikelnummer.Artikelnummer').AsString;
    PTC.Cells[3,i]:=xdspositionen.FieldByName('Artikelueberschrift').AsString;
    PTC.Cells[4,i]:=xdspositionen.FieldByName('Artikelbeschreibung').AsString;
    PTC.Cells[5,i]:='<p class="text-right">'+xdspositionen.FieldByName('Menge').AsString;

    if not einkauf then
    begin
      if form1.RCW.Verkaufspreise=true then
      begin
        PTC.Cells[6,i]:='<p class="text-right">'+formatfloat('#,##0.00',xdsPositionen.fieldbyname('Verkaufspreis').asfloat);
        PTC.Cells[7,i]:='<p class="text-right">'+formatfloat('#,##0.00',xdsPositionen.fieldbyname('Endpreis').asfloat);
      end
      else
      begin
        PTC.Cells[6,i]:='XXX';
        PTC.Cells[7,i]:='XXX';
        btnPDF.Enabled:=false;
      end;
    end;
    if einkauf then
    begin
      if form1.RCW.Einkaufspreise=true then
      begin
        PTC.Cells[6,i]:='<p class="text-right">'+formatfloat('#,##0.00',xdsPositionen.fieldbyname('Einkaufspreis').asfloat);
        PTC.Cells[7,i]:='<p class="text-right">'+formatfloat('#,##0.00',xdsPositionen.fieldbyname('Endpreis').asfloat);
      end
      else
      begin
        PTC.Cells[6,i]:='XXX';
        PTC.Cells[7,i]:='XXX';
        btnPDF.Enabled:=false;
      end;
    end;



    xdspositionen.Next;
  end;
end;

procedure TEinzelBeleg.LoadDFMValues;
begin
  inherited LoadDFMValues;

  TC := TTableControl.Create(Self);
  PTC := TTableControl.Create(Self);
  Container1 := THTMLContainer.Create(Self);
  Container2 := THTMLContainer.Create(Self);
  btnzurueck := TButton.Create(Self);
  btnPDF := TButton.Create(Self);
  xdsBeleg := TXDataWebDataSet.Create(Self);
  xdsPositionen := TXDataWebDataSet.Create(Self);
  WClient := TXDataWebClient.Create(Self);

  TC.BeforeLoadDFMValues;
  PTC.BeforeLoadDFMValues;
  Container1.BeforeLoadDFMValues;
  Container2.BeforeLoadDFMValues;
  btnzurueck.BeforeLoadDFMValues;
  btnPDF.BeforeLoadDFMValues;
  xdsBeleg.BeforeLoadDFMValues;
  xdsPositionen.BeforeLoadDFMValues;
  WClient.BeforeLoadDFMValues;
  try
    Name := 'EinzelBeleg';
    Width := 213;
    Height := 417;
    Caption := 'EinzelBeleg';
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    TC.SetParentComponent(Self);
    TC.Name := 'TC';
    TC.Left := 0;
    TC.Top := 189;
    TC.Width := 169;
    TC.Height := 143;
    TC.ElementClassName := 'table table-hover table-bordered table-striped';
    TC.HeightStyle := ssAuto;
    TC.WidthStyle := ssPercent;
    TC.BorderColor := clSilver;
    TC.ChildOrder := 2;
    TC.ColHeader := False;
    TC.ElementFont := efCSS;
    TC.ElementHeaderClassName := 'table-info';
    TC.ElementPosition := epIgnore;
    TC.ElementTableClassName := 'table table-hover table-bordered table-striped';
    TC.WordWrap := True;
    TC.ColCount := 2;
    PTC.SetParentComponent(Self);
    PTC.Name := 'PTC';
    PTC.Left := 0;
    PTC.Top := 338;
    PTC.Width := 169;
    PTC.Height := 48;
    PTC.ElementClassName := 'table table-hover table-bordered table-striped';
    PTC.HeightStyle := ssAuto;
    PTC.WidthStyle := ssPercent;
    PTC.BorderColor := clSilver;
    PTC.ChildOrder := 2;
    PTC.ColHeader := False;
    PTC.ElementFont := efCSS;
    PTC.ElementHeaderClassName := 'table-info';
    PTC.ElementPosition := epIgnore;
    PTC.ElementTableClassName := 'table table-hover table-bordered table-striped';
    PTC.WordWrap := True;
    PTC.ColCount := 2;
    Container1.SetParentComponent(Self);
    Container1.Name := 'Container1';
    Container1.Left := 0;
    Container1.Top := 0;
    Container1.Width := 169;
    Container1.Height := 41;
    Container1.HeightStyle := ssAuto;
    Container1.WidthStyle := ssPercent;
    Container1.ChildOrder := 4;
    Container1.ElementFont := efCSS;
    Container1.ElementPosition := epIgnore;
    Container2.SetParentComponent(Self);
    Container2.Name := 'Container2';
    Container2.Left := 0;
    Container2.Top := 47;
    Container2.Width := 169;
    Container2.Height := 41;
    Container2.ElementClassName := 'd-flex flex-wrap m-1';
    Container2.HeightStyle := ssAuto;
    Container2.WidthStyle := ssAuto;
    Container2.ChildOrder := 1;
    Container2.ElementFont := efCSS;
    Container2.ElementPosition := epIgnore;
    btnzurueck.SetParentComponent(Self);
    btnzurueck.Name := 'btnzurueck';
    btnzurueck.Left := 0;
    btnzurueck.Top := 158;
    btnzurueck.Width := 96;
    btnzurueck.Height := 25;
    btnzurueck.Caption := '<< zur'#252'ck';
    btnzurueck.ChildOrder := 4;
    btnzurueck.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnzurueck.ElementFont := efCSS;
    btnzurueck.ElementPosition := epIgnore;
    btnzurueck.HeightStyle := ssAuto;
    btnzurueck.HeightPercent := 100.000000000000000000;
    btnzurueck.WidthStyle := ssAuto;
    btnzurueck.WidthPercent := 100.000000000000000000;
    SetEvent(btnzurueck, Self, 'OnClick', 'btnzurueckClick');
    btnPDF.SetParentComponent(Self);
    btnPDF.Name := 'btnPDF';
    btnPDF.Left := 102;
    btnPDF.Top := 158;
    btnPDF.Width := 96;
    btnPDF.Height := 25;
    btnPDF.Caption := 'PDF';
    btnPDF.ChildOrder := 4;
    btnPDF.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnPDF.ElementFont := efCSS;
    btnPDF.ElementPosition := epIgnore;
    btnPDF.HeightStyle := ssAuto;
    btnPDF.HeightPercent := 100.000000000000000000;
    btnPDF.WidthStyle := ssAuto;
    btnPDF.WidthPercent := 100.000000000000000000;
    SetEvent(btnPDF, Self, 'OnClick', 'btnPDFClick');
    xdsBeleg.SetParentComponent(Self);
    xdsBeleg.Name := 'xdsBeleg';
    xdsBeleg.AfterOpen := xdsBelegAfterOpen;
    xdsBeleg.EntitySetName := 'Angebote';
    xdsBeleg.Connection := DM2.XDataWebConnection1;
    xdsBeleg.SubpropsDepth := 1;
    xdsBeleg.QueryString := '$expand=Kundennummer';
    xdsBeleg.Left := 476;
    xdsBeleg.Top := 72;
    xdsPositionen.SetParentComponent(Self);
    xdsPositionen.Name := 'xdsPositionen';
    xdsPositionen.AfterOpen := xdsPositionenAfterOpen;
    xdsPositionen.EntitySetName := 'PositionenAnfrage';
    xdsPositionen.Connection := DM2.XDataWebConnection1;
    xdsPositionen.SubpropsDepth := 1;
    xdsPositionen.QueryString := '$expand=Artikelnummer';
    xdsPositionen.Left := 476;
    xdsPositionen.Top := 128;
    WClient.SetParentComponent(Self);
    WClient.Name := 'WClient';
    WClient.Connection := DM2.XDataWebConnection1;
    WClient.Left := 72;
    WClient.Top := 98;
  finally
    TC.AfterLoadDFMValues;
    PTC.AfterLoadDFMValues;
    Container1.AfterLoadDFMValues;
    Container2.AfterLoadDFMValues;
    btnzurueck.AfterLoadDFMValues;
    btnPDF.AfterLoadDFMValues;
    xdsBeleg.AfterLoadDFMValues;
    xdsPositionen.AfterLoadDFMValues;
    WClient.AfterLoadDFMValues;
  end;
end;

end.